import { render, staticRenderFns } from "./TrainingRoom.vue?vue&type=template&id=3a189aba&"
import script from "./TrainingRoom.vue?vue&type=script&lang=ts&"
export * from "./TrainingRoom.vue?vue&type=script&lang=ts&"
import style0 from "./TrainingRoom.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports